import { FC } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import { localeStore } from 'src/mobx/localesStore';
import Icon from 'src/view/components/Controls/Icon/Icon';
import Text, { TEXT } from 'src/view/components/Text/Text';

interface IProps {
  maxFileSize: string | null;
  allowedFileTypes: string[];
}

const UploadValidation: FC<IProps> = ({ maxFileSize, allowedFileTypes }: IProps): JSX.Element => {
  return (
    <div className="upload__validation-block">
      <Icon name={Icons.Warning} color={theme.colors.red} size={80} className="mb-2" />
      {maxFileSize ? (
        <Text
          type={TEXT.ERROR}
          text={localeStore.t('file_size_must_be_less_than') + ': ' + maxFileSize}
          className="upload__validation-block-text text-size-18"
          noTranslate
        />
      ) : null}
      {allowedFileTypes.length ? (
        <Text
          type={TEXT.ERROR}
          text={localeStore.t('image_must_be_a_file_of_type') + ':' + String(allowedFileTypes)}
          className="upload__validation-block-text text-size-18"
          noTranslate
        />
      ) : null}
      {!maxFileSize && !allowedFileTypes.length ? (
        <Text type={TEXT.ERROR} text="smth_went_wrong" className="upload__validation-block-text text-size-18" />
      ) : null}
    </div>
  );
};

export default UploadValidation;
